// extracted by mini-css-extract-plugin
export default {"header":"CartAbandonmentFlow_header__7kcdr","wrapper":"CartAbandonmentFlow_wrapper__bfsgA"};